// import logo from "../imgs/logo.jpg";
// import logo_Old from "../imgs/logo-old.png";
// import knfLogo from "../imgs/company-logo.png";
// import knf_logo from "../imgs/KNF-Logo.png";
// import knf_main_logo from "../imgs/knf_main_logo.png";
// import profile from "../imgs/profile-icon.png";
// import noti_icon from "../imgs/noti-icon.png";
// import user_icon from "../imgs/admin-icon.png";
// import user_act from "../imgs/admin-act.png";
// import device_icon from "../imgs/device-icon.png";
// import device_act from "../imgs/device-act.png";
// import location_icon from "../imgs/location-icon.png";
// import location_act from "../imgs/location-act.png";
// import toggle_on from "../imgs/toggle-on.png";
// import toggle_off from "../imgs/toggle-off.png";
// import logout_icon from "../imgs/logout-icon.png";
// import company_icon from "../imgs/company-icon.png";
// import mobile_icon from "../imgs/mobile-icon.png";
// import email_icon from "../imgs/email-icon.png";
// import password_icon from "../imgs/password-icon.png";
// import delete_icon from "../imgs/delete-icon.png";
// import edit_icon from "../imgs/edit-icon.png";
// import eye_icon from "../imgs/eye_icon.png";
// import view_icon from "../imgs/view-icon.png";
// import company_role from "../imgs/company-role.png";
// import dummyimage from "../imgs/dummyimage.png";
// import search_icon from "./search-icon.png";
// import user from "./user.png";
// import merch_toggle_on from "./merch_toggle.png";
// import merch_toggle_off from "./merch_toggle_off.png";
// import red_icon from "./red_icon.png";
// import green_icon from "./green_icon.png";
// import construction from "./construction.jpg";
// import aiware_logo_png from "./AI-WARE-LOGO-PNG.png";
// import aiware_logo from "./AI-WARE-LOGO.png";

export const logo = require("../imgs/logo.jpg");
export const logo_Old = require("../imgs/logo-old.png");
export const company_logo = require("../imgs/company-logo.png");
export const knf_logo = require("../imgs/KNF-Logo.png");
export const knf_main_logo = require("../imgs/knf_main_logo.png");
export const profile = require("../imgs/profile-icon.png");
export const noti_icon = require("../imgs/noti-icon.png");
export const user_icon = require("../imgs/admin-icon.png");
export const user_act = require("../imgs/admin-act.png");
export const device_icon = require("../imgs/device-icon.png");
export const device_act = require("../imgs/device-act.png");
export const location_icon = require("../imgs/location-icon.png");
export const location_act = require("../imgs/location-act.png");
export const toggle_on = require("../imgs/toggle-on.png");
export const toggle_off = require("../imgs/toggle-off.png");
export const role_on = require("../imgs/role-on.png");
export const role_off = require("../imgs/role-off.png");
export const logout_icon = require("../imgs/logout-icon.png");
export const company_icon = require("../imgs/company-icon.png");
export const mobile_icon = require("../imgs/mobile-icon.png");
export const email_icon = require("../imgs/email-icon.png");
export const password_icon = require("../imgs/password-icon.png");
export const delete_icon = require("../imgs/delete-icon.png");
export const edit_icon = require("../imgs/edit-icon.png");
export const eye_icon = require("../imgs/eye_icon.png");
export const view_icon = require("../imgs/view-icon.png");
export const right_icon = require("../imgs/right_icon.png");
export const company_role = require("../imgs/company-role.png");
export const dummyimage = require("../imgs/dummyimage.png");
export const search_icon = require("./search-icon.png");
export const user = require("./user.png");
export const merch_toggle_on = require("./merch_toggle.png");
export const merch_toggle_off = require("./merch_toggle_off.png");
export const red_icon = require("./red_icon.png");
export const green_icon = require("./green_icon.png");
export const construction = require("./construction.jpg");
export const aiware_logo_png = require("./AI-WARE-LOGO-PNG.png");
export const aiware_logo = require("./AI-WARE-LOGO.png");
export const knfLogo = require("./knfLoginLogo.png");
export const default_img = require("./default.jpg");

// DashBoard
export const Graph_Icon = require("./Graph.png"); //1
export const MapPinArea_Icon = require("./MapPinArea.png"); //2
export const PipeWrench_Icon = require("./PipeWrench.png"); //3
export const Rows_Icon = require("./Rows.png"); //4
export const UserList_Icon = require("./UserList.png"); //5
export const Userss_Icon = require("./Users.png"); //6
export const Wall_Icon = require("./Wall.png"); //7
export const Warehouse_Icon = require("./Warehouse.png"); //8

// export {
//     knfLogo,
//     aiware_logo,
//     aiware_logo_png,
//     company_icon,
//     company_role,
//     construction,
//     delete_icon,
//     device_act,
//     device_icon,
//     dummyimage,
//     edit_icon,
//     email_icon,
//     eye_icon,
//     green_icon,
//     knf_logo,
//     knf_main_logo,
//     location_act,
//     location_icon,
//     logo,
//     logout_icon,
//     merch_toggle_off,
//     merch_toggle_on,
//     mobile_icon,
//     password_icon,
//     profile,
//     red_icon,
//     search_icon,
//     toggle_off,
//     toggle_on,
//     user,
//     user_act,
//     user_icon,
//     view_icon,
//     logo_Old,
//     noti_icon,
// };
